import useFlags from 'components/shared/useFlags'
import { useAuth } from 'services/auth'
/**
 * Custom hook to check if the current organization has RME v1.8 access
 * Organizations on controller v1.8 + FPGA 4.4.1 get the improved RME model
 * Uses an allowlist approach: organizations must be explicitly enabled or 'all' specified
 * @returns boolean indicating if RME v1.8 should be used
 */
export const useRmeV18Access = (): boolean => {
  const { user } = useAuth()
  const { rmeV18EnabledOrganizations } = useFlags()

  // If no user or no org_id, deny access
  if (!user || !user.org_id) {
    return false
  }

  // Parse the comma-separated list and check for exact 'all' match or org_id match
  const enabledOrgs = (rmeV18EnabledOrganizations ?? '')
    .split(',')
    .map(org => org.trim().toLowerCase())
    .filter(org => org.length > 0)

  if (enabledOrgs.includes('all')) {
    return true
  }

  return enabledOrgs.includes(user.org_id.toLowerCase())
}

export default useRmeV18Access
